import React from "react";
import {
  Container,
  Row,
  Col,
} from "reactstrap";

import ansys from "assets/img/partners/ansys.svg";
import aws from "assets/img/partners/aws.png";
import foley from "assets/img/partners/foley.svg";
import ge_additive from "assets/img/partners/ge-additive.png";
import massrobotics from "assets/img/partners/massrobotics.svg";
import mathworks from "assets/img/partners/mathworks.svg";
import nvidia from "assets/img/partners/nvidia-logo-horiz-1cwht-16x9.png";
import wsdev from "assets/img/partners/wsdev.jpg";

const partners = [
  {
    link: 'https://www.colibriumadditive.com/',
    imageSrc: ge_additive,
  },
  {
    link: 'https://www.massrobotics.org/',
    imageSrc: massrobotics,
  },
  {
    link: 'https://www.mathworks.com/',
    imageSrc: mathworks,
  },
  {
    link: 'https://www.ansys.com/',
    imageSrc: ansys,
  },
  {
    link: 'https://aws.amazon.com/',
    imageSrc: aws,
  },
  {
    link: 'https://www.foley.com/office/boston/',
    imageSrc: foley,
  },
  {
    link: 'https://www.nvidia.com/en-us/',
    imageSrc: nvidia,
  },
  {
    link: 'https://www.wsdevelopment.com/',
    imageSrc: wsdev,
  }
];

const Partners = () => {
  document.documentElement.classList.remove("nav-open");

  return (
    <div className="section section-maglev-blue text-center">
      <Container>
        <h1 className="title" style={{ color: 'white', fontWeight: 'bolder'}}>Partners</h1> 
        <Row className="justify-content-center">
          <Col md="10" className="mb-5">
            <div style={{ padding: '10px', borderRadius: '10px' }}>
              <Row className="justify-content-center">
                {partners.map((article, index) => (
                  <Col key={index} lg="4" md="4" sm="4" xs="6" className="mb-3">
                    <a href={article.link} target="_blank" rel="noopener noreferrer">
                      <div
                        style={{
                          width: '100%',
                          height: '120px',
                          borderRadius: '10px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          overflow: 'hidden',
                        }}
                      >
                        <img
                          src={article.imageSrc}
                          alt={`Partner ${index}`}
                          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        />
                      </div>
                    </a>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Partners;
